export default "__VITE_ASSET__$h5fDsHO__"